import { MediaSize } from './sizeCodes';
import {
  MEDIA_SIZE_40,
  MEDIA_SIZE_80,
  MEDIA_SIZE_160,
  MEDIA_SIZE_240,
  MEDIA_SIZE_320,
  MEDIA_SIZE_480,
  MEDIA_SIZE_640,
} from './sizes';

export const MEDIA_SIZE_MAP = {
  [MediaSize.XXSSmall]: MEDIA_SIZE_40,
  [MediaSize.XSmall]: MEDIA_SIZE_80,
  [MediaSize.Small]: MEDIA_SIZE_160,
  [MediaSize.SmallMedium]: MEDIA_SIZE_240,
  [MediaSize.Medium]: MEDIA_SIZE_320,
  [MediaSize.Large]: MEDIA_SIZE_480,
  [MediaSize.XLarge]: MEDIA_SIZE_640,
};
